import CrudPage from "../components/CrudPage";

export default function Categories() {
  return (
    <CrudPage
      title="Ana Kategoriler"
      subtitle="Ürün ana kategorilerini yönetin"
      module="categories"
      endpoint="/categories"
      addLabel="Yeni Kategori"
      columns={[
        { key: "name", label: "Kategori Adı", render: (r) => <span className="font-medium">{r.name}</span> },
        { key: "description", label: "Açıklama" },
      ]}
      fields={[
        { name: "name", label: "Kategori Adı", required: true },
        { name: "description", label: "Açıklama", type: "textarea" },
      ]}
    />
  );
}
